import type { SVGProps } from "react";
const SvgAnalysisSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 26 26" {...props}>
    <path
      className="icon-color-4"
      fill="#fff"
      stroke="currentColor"
      strokeLinejoin="round"
      d="M23.902 18.172a4.15 4.15 0 0 0-.114-.954l1.164-.673-1.185-2.053-1.162.671a4.135 4.135 0 0 0-1.68-.969v-1.342h-2.37v1.35c-.621.188-1.19.521-1.659.97l-1.178-.68-1.186 2.053 1.186.685c-.15.627-.149 1.28.006 1.906l-1.194.69 1.185 2.052 1.197-.69a4.14 4.14 0 0 0 1.644.954v1.377h2.37v-1.37a4.132 4.132 0 0 0 1.66-.952l1.18.681 1.185-2.052-1.17-.676c.079-.32.12-.649.122-.978Z"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      d="M21.546 18.172a1.792 1.792 0 1 1-3.583 0 1.792 1.792 0 0 1 3.583 0ZM14.5 13V7.519h5V11M7.5 24V.5h5V24M.5 24V11.5h5V24M0 25.5h26"
    />
  </svg>
);
export default SvgAnalysisSettings;
